module.exports = __webpack_public_path__ + "static/media/loaderLollipop.7efc2cb3.gif";